import { render, staticRenderFns } from "./arrival.vue?vue&type=template&id=a3635f48&scoped=true&"
import script from "./arrival.vue?vue&type=script&lang=js&"
export * from "./arrival.vue?vue&type=script&lang=js&"
import style0 from "./arrival.vue?vue&type=style&index=0&id=a3635f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3635f48",
  null
  
)

export default component.exports